function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRipple17S160Px = function SvgRipple17S160Px(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-ripple",
    style: {
      shapeRendering: "auto",
      animationPlayState: "running",
      animationDelay: "0s",
      background: "none"
    },
    ref: svgRef
  }, props), React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 37.4884,
    fill: "none",
    "ng-attr-stroke": "{{config.c1}}",
    "ng-attr-stroke-width": "{{config.width}}",
    stroke: "#243a52",
    strokeWidth: 2,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, React.createElement("animate", {
    attributeName: "r",
    calcMode: "spline",
    values: "0;40",
    keyTimes: "0;1",
    dur: 1.7,
    keySplines: "0 0.2 0.8 1",
    begin: "-0.85s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    values: "1;0",
    keyTimes: "0;1",
    dur: 1.7,
    keySplines: "0.2 0 0.8 1",
    begin: "-0.85s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })), React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 20.0507,
    fill: "none",
    "ng-attr-stroke": "{{config.c2}}",
    "ng-attr-stroke-width": "{{config.width}}",
    stroke: "#2680c0",
    strokeWidth: 2,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, React.createElement("animate", {
    attributeName: "r",
    calcMode: "spline",
    values: "0;40",
    keyTimes: "0;1",
    dur: 1.7,
    keySplines: "0 0.2 0.8 1",
    begin: "0s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }), React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    values: "1;0",
    keyTimes: "0;1",
    dur: 1.7,
    keySplines: "0.2 0 0.8 1",
    begin: "0s",
    repeatCount: "indefinite",
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRipple17S160Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ripple-1.7s-160px.f0569216.svg";
export { ForwardRef as ReactComponent };